"use client";

import useAllGamesNavigate from "@casino/client/components/AllGamesNavigation/useAllGamesNavigate";
import updateQueryParam from "@casino/client/utils/updateQueryParam/updateQueryParam";
import type { GameFilterGroup } from "@workspace/frontend-ui";
import { useCallback } from "react";

const useFilterSelect = (groups: GameFilterGroup[]) => {
  const navigate = useAllGamesNavigate();

  const push = useCallback(
    (href: string) => navigate(updateQueryParam(href, "page", undefined)),
    [navigate],
  );

  const select = useCallback(
    (groupId: string, value: string | undefined) =>
      push(updateQueryParam(location.href, groupId, value)),
    [push],
  );

  const clear = useCallback(
    () =>
      push(
        groups.reduce(
          (href, group) => updateQueryParam(href, group.id, undefined),
          location.href,
        ),
      ),
    [groups, push],
  );

  return { clear, select };
};

export default useFilterSelect;
